import * as React from 'react';
import { OpgaveDelopgaver } from '../../models/OpgaveDelopgaver';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { FilterControlsWrapper } from '../../uiComponents/layout/FilterControlsWrapper';
import { Grid, Row, Col, Panel } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { Konkurrence } from '../../models/Konkurrence';
import { DropDownFormGroup, MenuItemDto } from '../../uiComponents/input/FormGroups';
import { getSite } from '../../infrastructure/site/SiteProvider';
import { Image } from '../../uiComponents/layout/Image';
import { DelopgaveListItem } from '../../models/DelopgaveListItem';
import Table from '../../uiComponents/table/Table';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { BedoemmelseTabel } from '../../models/BedoemmelseTabel';
import { MultipleChoiceBesvarelse } from '../../models/MultipleChoiceBesvarelse';
import { ResultatAngivesIEnum } from '../../models/enums/ResultatAngivesIEnum';
import MultipleChoiceBesvarelsePresenter from './MultipleChoiceBesvarelsePresenter';
import { Spinner } from '../../uiComponents/Spinner';
import { getLoggedInBruger } from '../../infrastructure/Security';
import { BrugerRolleEnum } from '../../models/enums/BrugerRolleEnum';
import { ValidationError } from '../../infrastructure/ValidationResult';
import { formGroup } from '../../uiComponents/input/FormFunctions';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import { Hold } from '../../models/Hold';
import ForsoegIndtastningsfelt from './ForsoegIndtastningsfelt';
import HoldnavnOgBedommelsesFaktorerFelt from './HoldnavnOgBedoemmelsesFaktorerFelt';
import * as moment from 'moment';
import bedoemmesAfTilRolleMap from '../../models/mappers/BedoemmesAfTilRolleMap';

export interface OpgaveBedoemmelsePresenterProps {
    opgaver: OpgaveDelopgaver[];
    konkurrence: Konkurrence;
    valgtDelopgave?: DelopgaveListItem;
    valgtOpgaveId?: string;
    bedoemmelserTable?: BedoemmelseTabel;
    multipleChoiceBesvarelse?: MultipleChoiceBesvarelse;
    isSaving: boolean;
    validationError?: ValidationError;
    holdList?: Hold[];
    holdListIndtastning?: Hold[];
    valgtHold?: Hold;
    onDelopgaveChanged: (delopgaveId: string) => void;
    onOpgaveChanged: (opgaveId: string) => void;
    onForsoegAdded: (holdId: string, value: string) => Promise<boolean>;
    onForsoegDeleted: (forsoegId: string) => void;
    onMultipleChoiceSvar: (spoergsmaalId: string, svarmulighedId: string) => void;
    onIndsendBesvarelse: () => void;
    onHoldChanged: (holdId: string) => void;
    onStartDelopgave: (varighed: number | undefined) => void;
    onIndtastetValueChanged: (value: string, index: number) => void;
    onSamletResultatValueChanged: (value: string) => void;
    onSamletResultatSubmittet: (holdId: string) => void;
    startDelopgaveErrorMessages: ValidationError[];
    samletResultat: string;
    indtastedeValues: string[];
}

class OpgaveBedoemmelsePresenter extends React.Component<OpgaveBedoemmelsePresenterProps, any> {

    constructor(props: OpgaveBedoemmelsePresenterProps) {
        super(props);

        this.formatForsoeg = this.formatForsoeg.bind(this);
        this.formatIndtastning = this.formatIndtastning.bind(this);
        this.getBedoemmelseTableComponent = this.getBedoemmelseTableComponent.bind(this);
        this.getDelopgaveContent = this.getDelopgaveContent.bind(this);
        this.getMultipleChoiceComponent = this.getMultipleChoiceComponent.bind(this);
        this.formatHoldnavnOgBedoemmelsesFaktorer = this.formatHoldnavnOgBedoemmelsesFaktorer.bind(this);
    }

    formatForsoeg(cell: any, row: any) {
        const alleResultater = cell.map((c: any, i: number) =>
            <span key={i} className='badge' onClick={() => this.props.onForsoegDeleted(c.id)}>{c.value}</span>
        );

        return (
            <div className='badge-container' >
                {alleResultater}
            </div>
        );
    }

    formatIndtastning(cell: any, row: any) {
        var antalBedoemmelsesFaktorer = 0;
        if (this.props.valgtDelopgave !== undefined) {
            antalBedoemmelsesFaktorer = this.props.valgtDelopgave.delopgaveBedoemmelsesFaktorer.length;
        }

        const resultatAngivesI = this.props.valgtDelopgave ? this.props.valgtDelopgave.resultatetAngivesI : undefined;

        const input = (
            <ForsoegIndtastningsfelt
                holdId={row.holdId}
                onForsoegAdded={this.props.onForsoegAdded}
                antalBedoemmelsesFaktorer={antalBedoemmelsesFaktorer}
                resultatAngivesI={resultatAngivesI}
                indtastedeValues={this.props.indtastedeValues}
                samletResultat={this.props.samletResultat}
                onIndtastetValueChanged={this.props.onIndtastetValueChanged}
                onSamletResultatValueChanged={this.props.onSamletResultatValueChanged}
                onSamletResultatSubmittet={this.props.onSamletResultatSubmittet}
            />
        );

        let group = formGroup('', input, undefined);
        if (this.props.validationError !== undefined && this.props.validationError.field === row.holdId) {
            group = formGroup('', input, this.props.validationError);
        }

        return (
            <div>
                {group}
            </div>
        );
    }

    formatHoldnavnOgBedoemmelsesFaktorer(cell: any, row: any) {
        if (this.props.valgtDelopgave !== undefined) {
            return (
                <HoldnavnOgBedommelsesFaktorerFelt
                    holdNavn={row.holdNavn}
                    bedoemmelsesFaktorer={this.props.valgtDelopgave.delopgaveBedoemmelsesFaktorer}
                    resultatAngivesI={this.props.valgtDelopgave.resultatetAngivesI}
                />
            );
        }
        return <div />;
    }

    getDelopgaveContent() {
        const erElev = getLoggedInBruger().rolle === BrugerRolleEnum.Elev;

        if (erElev && this.props.valgtOpgaveId && this.props.valgtDelopgave) {
            if (this.props.valgtDelopgave && this.props.valgtDelopgave.resultatetAngivesI === ResultatAngivesIEnum.MultipleChoice) {
                return this.getMultipleChoiceComponent();
            } else {
                return this.getBedoemmelseTableComponent();
            }
        }

        if (this.props.valgtHold === undefined) {
            return (
                <Panel>
                    <div id='logo'>
                        <Image source={getSite().stortLogoName} alt='logo' />
                        {this.props.valgtOpgaveId === undefined &&
                            <h1>1. Vælg opgave</h1>
                        }
                        {this.props.valgtDelopgave === undefined && this.props.valgtOpgaveId !== undefined &&
                            <h1>2. Vælg delopgave</h1>
                        }
                        {this.props.valgtHold === undefined && this.props.valgtDelopgave !== undefined &&
                            <h1>3. Vælg hold</h1>
                        }
                    </div>

                </Panel>
            );
        } else {
            if (this.props.valgtDelopgave && this.props.valgtDelopgave.resultatetAngivesI === ResultatAngivesIEnum.MultipleChoice) {
                return this.getMultipleChoiceComponent();
            } else {
                return this.getBedoemmelseTableComponent();
            }
        }
    }

    onRegisterButtonClicked(hold?: Hold) {
        if (hold) {
            this.props.onSamletResultatSubmittet(hold.id);
        }
    }

    getBedoemmelseTableComponent() {
        if (this.props.valgtDelopgave === undefined) {
            throw Error;
        }

        if (this.props.bedoemmelserTable === undefined) {
            return <Spinner />;
        }

        const harFlereBedømmelsesfaktorer = this.props.valgtDelopgave && this.props.valgtDelopgave.delopgaveBedoemmelsesFaktorer.length > 0;

        const flereBedommelsesfaktorerClass = harFlereBedømmelsesfaktorer ? 'flere-bedommelsesfaktorer-td' : '';
        const indtastForsoegClass = harFlereBedømmelsesfaktorer ? 'column-indtast-forsoeg-td' : '';

        const holdId = this.props.valgtHold !== undefined ? this.props.valgtHold.id : '';
        const valgtBedoemmelse = this.props.bedoemmelserTable.bedoemmelser.filter(b => b.holdId === holdId);

        const holdSkoleColumnWidth = harFlereBedømmelsesfaktorer ? '70%' : '50%';
        const forsøgColumnWidth = harFlereBedømmelsesfaktorer ? '20%' : '35%';

        return (
            <div>
                {this.props.valgtHold &&
                    <div>
                        <h4>Du skal bedømme</h4>
                        <p>{this.props.valgtDelopgave.bedoemmelsesvejledning}</p>
                        <SectionGroup header={this.props.bedoemmelserTable.bedoemmelser.length + ' hold'}>
                            <Section fullWidth={true}>
                                <Table data={valgtBedoemmelse} emptyText='Ingen bedømmelser'>
                                    <TableHeaderColumn dataField='holdId' isKey={true} hidden={true} dataAlign='center' />
                                    <TableHeaderColumn
                                        width={holdSkoleColumnWidth}
                                        dataFormat={this.formatHoldnavnOgBedoemmelsesFaktorer}
                                        className='first'
                                        columnClassName='first'
                                    >
                                        Hold, skole
                                    </TableHeaderColumn>
                                    <TableHeaderColumn width='30%' dataFormat={this.formatIndtastning} columnClassName={indtastForsoegClass}>Indtast forsøg</TableHeaderColumn>
                                    <TableHeaderColumn
                                        width={forsøgColumnWidth}
                                        dataField='forsoeg'
                                        dataFormat={this.formatForsoeg}
                                        columnClassName={flereBedommelsesfaktorerClass}
                                    >
                                        Forsøg
                                    </TableHeaderColumn>
                                    <TableHeaderColumn width='30%' dataField='bedsteForsoeg' columnClassName={flereBedommelsesfaktorerClass}>Bedste forsøg</TableHeaderColumn>
                                </Table>
                            </Section>
                            <Section>
                                <button onClick={() => this.onRegisterButtonClicked(this.props.valgtHold)} className='btn btn-primary'>Registrer forsøg</button>
                            </Section>
                        </SectionGroup>

                    </div>
                }
            </div>
        );
    }

    getMultipleChoiceComponent() {
        if (this.props.multipleChoiceBesvarelse === undefined) {
            return <Spinner />;
        }

        return (
            <MultipleChoiceBesvarelsePresenter
                multipleChoiceBesvarelse={this.props.multipleChoiceBesvarelse}
                onMultipleChoiceSvarChanged={this.props.onMultipleChoiceSvar}
                delopgave={this.props.valgtDelopgave === undefined ? new DelopgaveListItem : this.props.valgtDelopgave}
                onIndsendBesvarelse={this.props.onIndsendBesvarelse}
                isSaving={this.props.isSaving}
                onStartDelopgave={this.props.onStartDelopgave}
                startDelopgaveErrorMessages={this.props.startDelopgaveErrorMessages}
                konkurrenceId={this.props.konkurrence.id}
            />
        );
    }

    render() {
        let opgaverBrugerKanBedoemme = this.props.opgaver;
        const loggedInRolle = getLoggedInBruger().rolle;
        if (loggedInRolle !== BrugerRolleEnum.Administrator) {
            opgaverBrugerKanBedoemme = this.props.opgaver
                .filter(o => o.delopgaver.some(d => bedoemmesAfTilRolleMap(d.opgavenBedoemmesAf).indexOf(loggedInRolle) !== -1));
        }

        let opgaveListItems = opgaverBrugerKanBedoemme.map(o =>
            new MenuItemDto(o.id, o.titel)
        );

        let delopgaveListItems: MenuItemDto[] = [];
        if (this.props.valgtOpgaveId !== undefined) {
            let delopgaver = this.props.opgaver
                .filter(o => o.id === this.props.valgtOpgaveId)[0].delopgaver;

            if (loggedInRolle !== BrugerRolleEnum.Administrator) {
                delopgaver = delopgaver.filter(d => bedoemmesAfTilRolleMap(d.opgavenBedoemmesAf).indexOf(loggedInRolle) !== -1);
            }

            delopgaveListItems = delopgaver.map((o, i) => new MenuItemDto(o.id, o.titel));
        }

        let holdList: MenuItemDto[] = [];
        if (this.props.holdListIndtastning !== undefined) {
            holdList = this.props.holdListIndtastning.map(h => new MenuItemDto(h.id, h.navn + ' - ' + h.institution.navn));
        }

        const startDate = moment(new Date(this.props.konkurrence.startdato)).format('DD.MM.YY');

        let title = startDate + ' ' + this.props.konkurrence.titel;

        return (

            <PageWrapper>
                <PageTitle title={title} />
                <FilterControlsWrapper>
                    <Grid>
                        <Row>
                            <Col md={4}>
                                <DropDownFormGroup
                                    items={opgaveListItems}
                                    name='opgave'
                                    label='Opgave'
                                    selectedValue={this.props.valgtOpgaveId}
                                    onChange={(fieldName: string, value: any) => this.props.onOpgaveChanged(value)}
                                    ingenValgtText='Vælg opgave'
                                />
                            </Col>
                            <Col md={4}>
                                <DropDownFormGroup
                                    items={delopgaveListItems}
                                    name='delOpgave'
                                    label='Delopgave'
                                    selectedValue={this.props.valgtDelopgave === undefined ? undefined : this.props.valgtDelopgave.id}
                                    onChange={(fieldName: string, value: any) => this.props.onDelopgaveChanged(value)}
                                    ingenValgtText='Vælg delopgave'
                                />
                            </Col>
                            {this.props.holdListIndtastning !== undefined && this.props.valgtDelopgave !== undefined &&
                                <Col md={4}>
                                    <DropDownFormGroup
                                        items={holdList}
                                        name='holdList'
                                        label='Hold'
                                        selectedValue={this.props.valgtHold === undefined ? undefined : this.props.valgtHold.id}
                                        onChange={(fieldName: string, value: any) => this.props.onHoldChanged(value)}
                                        ingenValgtText='Vælg hold'
                                    />
                                </Col>
                            }
                        </Row>
                    </Grid>
                </FilterControlsWrapper>
                <ContentWrapper>
                    <div id='opgave-bedoemmelse'>
                        {this.getDelopgaveContent()}
                    </div>
                </ContentWrapper>
            </PageWrapper>
        );
    }
}

export default OpgaveBedoemmelsePresenter;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgaveBedoemmelse/OpgaveBedoemmelsePresenter.tsx